import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export function resolveClearDstWarningUrl(activeCartId: string): string {
  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/warnings/dst`);
}

export async function sendInfoWanrSeenCart() {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot clear Cart warning without an explicit Active Cart identity");
  }
  return occFetch(resolveClearDstWarningUrl(activeCartId), {
    method: "DELETE",
  });
}
